module.exports = __webpack_public_path__ + "img/BMI.f942f9ee.jpg";